/**
 * SYNCED ENUM: Values in frontend and backend versions of ZendeskTag must be synced!
 *
 * Any changes here should reflect valid options in the backend enum at:
 * monoweb.django_apps.preventive_care.patient_messaging.constants.ZendeskTag
 */
export enum ZendeskTag {
  CUSTOMER_SHOESTRING = 'customer-shoestring',
  CUSTOMER_COLOR = 'customer-color',
  CUSTOMER_RAINBOW = 'customer-rainbow',
  CUSTOMER_REDBULL = 'customer-redbull',
  CUSTOMER_LDCT_ACS = 'customer-ldctacs',
  CUSTOMER_LDCT_ACS_OLD = 'customer-ldctACS',
  WELCOME_CONVERSATION = 'welcome-conversation',
  // TODO TELE-2511: maintaining this for backwards compatibility, but we should deprecate soon
  WELCOME_MESSAGE = 'welcome-message',
  PROVIDER_INITIATED = 'provider-initiated',
  COMPLETE_HRA_REMINDER = 'complete-hra-reminder',
  COMPLETE_AI_REMINDER = 'complete-ai-reminder',
  SCHEDULING_CARE_COORDINATION = 'scheduling-care-coordination',
  SCHEDULING_CARE_ADVOCATE = 'scheduling-care-advocate',
  SCHEDULING_COLOR_MEDICAL = 'scheduling-color-medical',
  CANCER_BREAST = 'cancer-breast',
  CANCER_CERVICAL = 'cancer-cervical',
  CANCER_COLORECTAL = 'cancer-colorectal',
  CANCER_LUNG = 'cancer-lung',
  CANCER_PROSTATE = 'cancer-prostate',
  CANCER_SKIN = 'cancer-skin',
  CANCER_GENETIC_TESTING = 'cancer-genetic-testing',
  COMPLETED_HRA_NO_AIS = 'completed-hra-no-ais',
  INCOMPLETE_HRA = 'incomplete-hra',
  IPS_ROUTING = 'ips-routing',
  ABNORMAL1YR = 'abnormal1yr',
  VIRTUAL_VISIT_LEVEL_1 = 'virtual-visit-level-1',
  VIRTUAL_VISIT_ACTION_ITEMS = 'virtual-visit-action-items',
  VIRTUAL_VISIT_HEART_HEALTH = 'virtual-visit-heart-health',
  VIRTUAL_VISIT_CANCER_BREAST = 'virtual-visit-cancer-breast',
  VIRTUAL_VISIT_CANCER_CERVICAL = 'virtual-visit-cancer-cervical',
  VIRTUAL_VISIT_CANCER_COLORECTAL = 'virtual-visit-cancer-colorectal',
  VIRTUAL_VISIT_CANCER_LUNG = 'virtual-visit-cancer-lung',
  VIRTUAL_VISIT_CANCER_PROSTATE = 'virtual-visit-cancer-prostate',
  VIRTUAL_VISIT_CANCER_PROSTATE_URGENT = 'virtual-visit-cancer-prostate-urgent',
  VIRTUAL_VISIT_CANCER_SKIN = 'virtual-visit-cancer-skin',
  VIRTUAL_VISIT_CANCER_OTHER = 'virtual-visit-cancer-other',
  VIRTUAL_VISIT_SKIN_CONCERNS = 'virtual-visit-skin-concerns',
  VIRTUAL_VISIT_GENETIC_TEST_RESULTS = 'virtual-visit-genetic-test-results',
  VIRTUAL_VISIT_GENETIC_RISK_FACTORS = 'virtual-visit-genetic-risk-factors',
  VIRTUAL_VISIT_QUIT_SMOKING = 'virtual-visit-quit-smoking',
  SCREENING_BREAST_CANCER = 'screening-breast-cancer',
  SCREENING_CERVICAL_CANCER = 'screening-cervical-cancer',
  SCREENING_COLORECTAL_CANCER = 'screening-colorectal-cancer',
  SCREENING_LUNG_CANCER = 'screening-lung-cancer',
  SCREENING_SKIN_CANCER = 'screening-skin-cancer',
  OUTREACH_1_HRA_COMPLETE_REMINDER = 'outreach-1-hra-complete-reminder',
  OUTREACH_2_HRA_COMPLETE_REMINDER = 'outreach-2-hra-complete-reminder',
  OUTREACH_1_KIT_RETURN_REMINDER = 'outreach-1-kit-return-reminder',
  OUTREACH_2_KIT_RETURN_REMINDER = 'outreach-2-kit-return-reminder',
  OUTREACH_1_KIT_ACTIVATION_REMINDER = 'outreach-1-kit-activation-reminder',
  OUTREACH_2_KIT_ACTIVATION_REMINDER = 'outreach-2-kit-activation-reminder',
  OUTREACH_1_AI_COMPLETE_REMINDER = 'outreach-1-ai-complete-reminder',
  OUTREACH_2_AI_COMPLETE_REMINDER = 'outreach-2-ai-complete-reminder',
  OUTREACH_1_VIRTUAL_VISIT_REMINDER = 'outreach-1-virtual-visit-reminder',
  OUTREACH_2_VIRTUAL_VISIT_REMINDER = 'outreach-2-virtual-visit-reminder',
  OUTREACH_3_VIRTUAL_VISIT_REMINDER = 'outreach-3-virtual-visit-reminder',
  OUTREACH_4_VIRTUAL_VISIT_REMINDER = 'outreach-4-virtual-visit-reminder',
  OUTREACH_1_SCREENING_REMINDER = 'outreach-1-screening-reminder',
  OUTREACH_2_SCREENING_REMINDER = 'outreach-2-screening-reminder',
  OUTREACH_3_SCREENING_REMINDER = 'outreach-3-screening-reminder',
  OUTREACH_4_SCREENING_REMINDER = 'outreach-4-screening-reminder',
  PATIENT_INITIATED = 'patient-initiated',
  NEEDS_CAT_FOLLOWUP = 'needs-cat-followup',
  UNABLE_TO_REACH = 'unable_to_reach',
  UNABLE_TO_REACH_CM = 'unable_to_reach__cm_',
  NA = 'n/a',
  SCHEDULING_IN_PROGRESS = 'scheduling_in_progress',
  SELF_SCHEDULED = 'self_scheduled',
  SCHEDULED_PREVIOUSLY = 'scheduled_previously',
  DECLINED_BUT_CAN_CHECK_BACK = 'declined_but_can_check_back',
  DECLINED = 'declined',
  CLOSED_BY_MERGE = 'closed_by_merge',
  NORMAL_AT_HOME_RESULTS = 'normal_at_home_results',
  SCHEDULED = 'scheduled',
  URGENT_SYMPTOM_OUTREACH = 'urgent_symptom_outreach',
  NEW_LUMP_IN_YOUR_BREAST_OR_UNDER_YOUR_ARM = 'new_lump_in_your_breast_or_under_your_arm',
  PAIN_IN_ANY_AREA_OF_THE_BREAST = 'pain_in_any_area_of_the_breast',
  RECTAL_BLEEDING = 'rectal_bleeding',
  BLOOD_IN_THE_STOOL = 'blood_in_the_stool',
  BREAST_SYMPTOMS = 'breast_symptoms',
  COUGHING_UP_BLOOD = 'coughing_up_blood',
  VAGINAL_BLEEDING_AFTER_MENOPAUSE = 'vaginal_bleeding_after_menopause',
  SHORTNESS_OF_BREATH = 'shortness_of_breath',
  HEALTH_HISTORY_QUICK_UPDATE = 'health_history_quick_update',
  RECTAL_BLEEDING_AND_BLOOD_IN_THE_STOOL = 'rectal_bleeding_and_blood_in_the_stool',
  NIPPLE_SYMPTOMS = 'nipple_symptoms',
  URGENT_SYMPTOM_OUTREACH_PRE_2025 = 'urgent_symptom_outreach_pre_2025',
  REDACTED_CONTENT = 'redacted_content',
  DERMATOLOGY_APPOINTMENT = 'dermatology_appointment',
  SCREENING_LUNG_CT = 'screening-lung-ct',
  SCREENING_LUNG_CT_UNDERSCORE = 'screening_lung_ct',
  URGENT_SYMPTOM_UNITED_NON_PLAN = 'urgent_symptom_united_non_plan',
  BULK_OUTREACH = 'bulk_outreach',
  AUTO_SOLVED_TICKET = 'auto_solved_ticket',
  IN_AND_POST_TREATMENT_SUPPORT = 'in_and_post_treatment_support',
  // These tags are currently only being used for the Google BCAM population
  UNINSURED = 'uninsured',
  INSURED = 'insured',
  SELECTED_FACILITY = 'selected-facility',
  NO_SELECTED_FACILITY = 'no-selected-facility',
  SYMPTOMS = 'symptoms',
  HIGH_RISK = 'high-risk',
  HIGH_RISK_COHORT = 'high-risk-cohort',
  UNDER_40 = 'under-40',
  EAST_COAST_STATE = 'east-coast-state',
  WEST_COAST_STATE = 'west-coast-state',
  CENTRAL_STATE = 'central-state',
  FUSION = 'fusion',
  CRAV2_CONCERN = 'crav2_concern',
  // This tag indicates the ticket is only for sharing internal comments with Maven
  MAVEN_SHARING = 'maven-sharing',
  ABNORMAL = 'abnormal',
  GENETICS = 'genetics',
  CRA_INITIATED_IPS = 'cra-initiated-ips',
  MAMMO_REQUEST = 'mammo-request',
  BREAST_MRI_REQUEST = 'breast-mri-request',
  PAP_REQUEST = 'pap-request',
  COLONOSCOPY_REQUEST = 'colonoscopy-request',
  LDCT_REQUEST = 'ldct-request',
}
